/**
 * Search constants.
 */
export class SearchResults {
  static GAUGE = 'gauge';
  static PLACE = 'place';
}